import {ApiService} from '../../../core/services/api.service';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../../core/shared/classes/api';
import {Injectable} from '@angular/core';
import {FactureSearchTerms, FactureServiceInterface} from './facture-service-interface';
import {FactureNormalize} from '../classes/facture-normalize';
import {FactureDetailNormalize} from '../classes/facture-detail-normalize';
import { IMultipleSort } from '../../../infrastructure/shared/classes/multiple-sort';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class FactureFournisseurService implements FactureServiceInterface {
    constructor(private apiService: ApiService) {}

    fetchAll(params: FactureSearchTerms, page, maxPageCount, options?: {sort: IMultipleSort[]}): Observable<ApiResponse> {
        if (page)
            params['page'] = page;
        if (maxPageCount)
            params['maxPageCount'] = maxPageCount;
        params.withSolde = true;
        if (options) {
            params.sort = options.sort.map(sort => `${sort.column}|${sort.direction}`).join(';');
        }
        
        return this.apiService.get(`facture/fournisseur`, null, params);
    }

    fetchByCommandeId(commandeId): Observable<ApiResponse> {
        return this.apiService.get(`facture/fournisseur/commande/${commandeId}`);
    }

    fetchById(id): Observable<ApiResponse> {
        return  this.apiService.get(`facture/fournisseur/${id}`);
    }

    fetchAllRoles(bureauId, batimentId = null, banqueId?): Observable<ApiResponse> {
        const params = {};

        if (bureauId)
            params['bureauId'] = bureauId;
        if (batimentId)
            params['batimentId'] = batimentId;
        if (banqueId !== undefined)
            params['banqueId'] = batimentId;

        return this.apiService.get('facture/fournisseur/roles', null, params);
    }

    fetchAllMaitresOuvrage(bureauId, batimentId = null, banqueId?): Observable<ApiResponse> {
        const params = {};

        if (bureauId)
            params['bureauId'] = bureauId;
        if (batimentId)
            params['batimentId'] = batimentId;
        if (banqueId !== undefined)
            params['banqueId'] = batimentId;

        return this.apiService.get('facture/fournisseur/maitres-ouvrage', null, params);
    }

    fetchAllLots(bureauId, withPartenaire = null): Observable<ApiResponse> {
        const params = {};

        if (bureauId)
            params['bureauId'] = bureauId;
        if (withPartenaire){
            params['withPartenaire'] = withPartenaire;
        } else {
            params['withPartenaire'] = false;
        }

        return this.apiService.get('facture/fournisseur/lots', null, params);
    }

    fetchAllLotsIds(bureauId, withPartenaire = null): Observable<ApiResponse> {
        const params = {};

        if (bureauId)
            params['bureauId'] = bureauId;
        if (withPartenaire){
            params['withPartenaire'] = withPartenaire;
        } else {
            params['withPartenaire'] = false;
        }

        return this.apiService.get('facture/fournisseur/lots/id', null, params);
    }

    fetchAllBatiment(bureauId): Observable<ApiResponse> {
        const params = {};

        if (bureauId)
            params['bureauId'] = bureauId;

        return this.apiService.get('facture/fournisseur/batiments', null, params);
    }

    createFactureFournisseur(data): Observable<ApiResponse> {
        return this.apiService.post('facture-fournisseur', JSON.stringify(data));
    }

    updateFactureFournisseur(id, data): Observable<ApiResponse> {
        return this.apiService.put('facture-fournisseur/' + id, JSON.stringify(data));
    }

    copyFacture(id): Observable<ApiResponse> {
        return this.apiService.post(`facture/fournisseur/copy/${id}`, []);
    }

    factureDetailNormalizer(data: {}): FactureDetailNormalize {
        const res = {};

        Object.keys(data).forEach(elem => {
            const tmp = elem.replace('ffd_', '');
            res[tmp] = data[elem];
        });

        return  new FactureDetailNormalize(res);
    }


    factureNormalizer(data: {}): FactureNormalize {
        const res = {};

        Object.keys(data).forEach(elem => {
            const tmp = elem.replace('ffo_', '');
            if (elem === 'details')
                res[tmp] = data[elem].map(item => this.factureDetailNormalizer(item));
            else
                res[tmp] = data[elem];
        });

        const fac = new FactureNormalize(res);
        fac.factureType = 'fournisseur';
        return fac;
    }

    contrePassation(id): Observable<ApiResponse> {
        return this.apiService.delete(`facture/fournisseur/${id}`);
    }

    generatePdf(id): Observable<ApiResponse> {
        return  this.apiService.get(`facture/fournisseur/pdf/${id}`);
    }

    regeneratePdf(data): Observable<ApiResponse> {
        return  this.apiService.post(`facture/fournisseur/pdf/regenerate/`, JSON.stringify(data));
    }

    hasNoteCredit(id): Observable<ApiResponse> {
        const params = {};

        if (id)
            params['id'] = id;

        return this.apiService.get('facture/fournisseur/note', null, params);
    }

    exportFacture(bureauId, data: any): Observable<ApiResponse> {
        return this.apiService.post(`facture/fournisseur/export/${bureauId}`, JSON.stringify(data));
    }

    generateGlobalPdf(data: {arrayId: string|number[], type: string}): Observable<Blob> {
        return  this.apiService.post(`facture/fournisseur/pdf-multiple`, JSON.stringify(data), {responseType: 'blob'});
    }
    
    generateNewRef(bureauId) {
        return this.apiService.get(`facture/fournisseur/reference/${bureauId}`);
    }
    
    getFacturesByIds(data): Observable<ApiResponse> {
        let params = new HttpParams().set('ids', data.join(','));

        return this.apiService.get(`facture/fournisseur/coda/liste`, { params });
    }
    validationFournisseur(data) : Observable<ApiResponse> {
        return this.apiService.post('validation-fournisseur', data);
    }

    receptionValidationFournisseur(data): Observable<ApiResponse> {
        return this.apiService.post('validation-fournisseur/reception', data);
    }

    fetchAllFacturesForChecking(): Observable<ApiResponse> {
        return  this.apiService.get(`suivi-fournisseur/`);
    }

    fetchAllColonnesSuiviFournisseur(): Observable<ApiResponse> {
        return  this.apiService.get(`facture/suivi-fournisseur/listing/`);
    }

    updateDemandeFacturation(id): Observable<ApiResponse> {
        return this.apiService.put('facture/demande-validation-fournisseur/' + id);
    } 
    
}
